import React from 'react';
import {Button, Card, Icon, List} from 'semantic-ui-react';
import CustomDivider from "../extras/CustomDivider";
import {FormattedNumber} from "react-intl";
import {choicePlan} from "../../actions/PlanesActions";
import {connect} from "react-redux";
import {selectPrice} from "../../actions/PricesActions";

const PlanCard = (props) =>{
        return (
            <Card>
                <Card.Content textAlign={'center'}>
                    <Card.Header textAlign={'center'} className={'titlePrice'}>{props.plan.name}</Card.Header>
                    <CustomDivider/>
                    <Card.Description>
                        <List divided relaxed>
                            {
                                props.plan.descriptions.map(function(description, index) {
                                    return (
                                        <List.Item key={index}>
                                            <List.Content>
                                                <List.Header><Icon name='check'/>{description}</List.Header>
                                            </List.Content>
                                        </List.Item>
                                    )
                                })
                            }
                        </List>
                    </Card.Description>
                    <CustomDivider/>
                    {props.plan.initial_price >= 0 ? <Card.Header textAlign={'center'} className={'titlePrice'}>
                        $<FormattedNumber value={props.plan.initial_price} currency="USD" maximumFractionDigits={0} minimumFractionDigits={0}/>
                        </Card.Header>:null}

                    {props.plan.initial_price >= 0 ?<Card.Meta textAlign='center' attached='bottom'>COP - Mes</Card.Meta>:null}
                    {
                        props.plan.initial_price > 0 ?
                            <span>
                                <CustomDivider/>
                                <Button fluid primary onClick={()=>props.selectPlan(props)}>
                                    Seleccionar
                                </Button>
                            </span>:null
                    }
                    {
                        props.plan.initial_price === -1 ?
                            <span>
                                <List.Item>
                                    <List.Content>
                                        <List.Header><a href="mailto:hola@quipuu.com">hola@quipuu.com</a></List.Header>
                                    </List.Content>
                                </List.Item>
                                <List.Item>
                                    <List.Content>
                                        <List.Header><a href="tel:3178282898">(+57) 317 8282 898</a></List.Header>
                                    </List.Content>
                                </List.Item>
                            </span>:null
                    }
                </Card.Content>
            </Card>
        );
};

const mapDispatchToProps = dispatch => {
    return {
        selectPlan(props) {
            dispatch(selectPrice({id:null}));
            dispatch(choicePlan(props.plan));
            props.callbackSelected(props.plan);
        }
    }
};

export default connect(
    null,
    mapDispatchToProps
)(PlanCard);


// WEBPACK FOOTER //
// ./src/components/settings/PlanCard.js